import { c as _c } from "react/compiler-runtime";
import { ThemedLogoFpFull } from '@onefootprint/icons';
const PaperFooter = t0 => {
  const $ = _c(5);
  const {
    note
  } = t0;
  let t1;
  if ($[0] !== note) {
    t1 = <p className="text-[11px] leading-snug text-neutral-500 italic">{note}</p>;
    $[0] = note;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-neutral-400 shrink-0"><ThemedLogoFpFull aria-label="Footprint" className="h-5 w-auto" /></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <footer className="pt-4 border-t border-neutral-200 flex items-center justify-between gap-6">{t1}{t2}</footer>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default PaperFooter;